<!-- 旗舰话费 -->
<template>
  <div>

    <!-- 头部 -->
    <header class="hero">
      <div class="inner">
        <div class="bar">
          <div class="brand"><span class="logo"></span>抖音充值</div>
          <span class="safe">安全交易</span>
        </div>
        <div class="eyebrow">DOUYIN MOBILE TOP-UP</div>
        <div class="title-row">
          <span class="timer-box"><span class="tl">剩余时间</span><span class="tv" id="timer">{{payTimeInfo.timePayoutMin}}:{{payTimeInfo.timePayoutSec}}</span></span>
          <h1>充值话费</h1>
        </div>
        <p class="lead">点击底部按钮会自动复制手机号，然后唤起抖音。请严格按订单金额完成充值。</p>
        <div class="chips">
          <span class="chip">我</span>
          <span class="chip hot">≡ 右上角</span>
          <span class="chip">我的钱包</span>
          <span class="chip">手机充值</span>
        </div>
      </div>
    </header>

    <div class="stack">
      <!-- 金额/号码卡 -->
      <section class="white">
        <div class="amt-top"><span class="l">本次充值金额</span><span class="r">话费充值</span></div>
        <div class="amt pending" id="amt" v-if="orderInfo.orderId==null">
          <span class="y">¥</span>--
        </div>
        <div class="amt" id="amt" v-else>
          <span class="y">¥</span>{{orderInfo.amount.toFixed(2)}}
        </div>
        <div class="phone-box">
          <div class="lbl">指定充值手机号</div>
          <div class="num pending" id="phone" v-if="orderInfo.orderId==null">匹配后显示</div>
          <div class="num pending" id="phone" v-else>{{orderInfo.phone}}</div>
          <div class="tip"><span class="dot"></span>点击底部按钮后会自动复制</div>
        </div>
        <div class="owner-box" v-if="orderInfo.orderId!=null&&orderInfo.ownerNeed==1">
          <div class="olbl">机主姓名</div>
          <div class="name-chars" v-if="orderInfo.orderId!=null">
            <div class="nchar" data-copy="*" v-for="(item, index) in orderInfo.phoneOwners" :key="index" @click="copyPhoneOwnerOne(item)">{{item}}</div>
          </div>
          <div class="ohint">充值时如需输入姓名，请按上方姓名填写；点击单字可复制。</div>
        </div>
        <!-- <div class="divider"></div> -->
        <!-- <div class="order"><span>订单编号</span><b>20260826170434691250 1014</b></div>
        <div class="matching-hint" id="mhint">正在安全匹配充值信息，请稍候</div> -->
      </section>

      <!-- 充值路径 -->
      <section class="white htp">
        <div class="kick">HOW TO PAY</div>
        <h2>抖音充值路径</h2>
        <p class="sub">唤起抖音后，按下方步骤进入手机充值，粘贴已复制的号码。</p>
        <div class="steps">
          <div class="step"><span class="n">01</span><span>打开抖音，进入右下角<em>"我"</em></span></div>
          <div class="step"><span class="n">02</span><span>点击右上角<em>"≡"</em></span></div>
          <div class="step"><span class="n">03</span><span>选择<em>"我的钱包"</em>和<em>"手机充值"</em></span></div>
          <div class="step"><span class="n">04</span><span>粘贴手机号，选择<em>指定金额</em></span></div>
        </div>
      </section>

      <!-- 支付前请确认 -->
      <section class="white confirm">
        <div class="ttl"><span class="cap"></span>支付前请确认</div>
        <ul>
          <li>必须粘贴页面显示的手机号，并充值<b>指定金额</b>。</li>
          <li>不要修改号码、金额或支付方式，<b>不要重复支付</b>。</li>
          <li>请在倒计时结束前付款，超时支付无法到账。</li>
          <li>付款后请等待 5–10 分钟；未到账可联系客服查询。</li>
          <li>请勿骚扰机主，订单需在 24 小时内查询。</li>
        </ul>
      </section>
    </div>

    <!-- 底部按钮 -->
    <div class="footer">
      <div class="fi">
        <div class="safe-tag">安全保障<br>资金无忧</div>
        <button class="btn" id="mainBtn" disabled v-if="orderInfo.orderId==null">
          匹配中，请耐心等待 <span id="sec">{{payTimeInfo.timeDownNo}}</span> 秒
        </button>
        <button class="btn" id="mainBtn" @click="gotoDy(orderInfo.phone)" v-else>
          复制号码 + 打开抖音
        </button>
      </div>
    </div>

    <!-- 匹配中弹窗 -->
    <div class="mask" id="maskMatch" v-if="orderInfo.orderId==null">
      <div class="modal" v-if="payTimeInfo.timeDownNo>0">
        <div class="mh">匹配中，请耐心等待</div>
        <div class="mb" style="text-align:center;">
          <div class="mring"><i>♪</i></div>
          <p>正在获取订单信息，通常只需十几秒钟</p>
          <div class="msec"><span id="msec">{{payTimeInfo.timeDownNo}}</span> 秒</div>
        </div>
      </div>
      <div class="modal" v-else>
        <div class="mh">失败</div>
        <div class="mb" style="text-align:center;">
          <div class="mring"><i>♪</i></div>
          <p>订单获取失败，请关闭页面或重新下单</p>
          <div class="msec">OK</div>
        </div>
      </div>
    </div>

    <!-- 记住机主姓名弹窗 -->
    <div class="mask" id="maskName" v-if="payTimeInfo.timeLastSss>0&&orderInfo.orderId!=null&&dialogPhoneOwner&&orderInfo.ownerNeed==1">
      <div class="modal">
        <div class="mh">请记住机主姓名</div>
        <div class="mb" style="text-align:center;">
          <p>充值时如需验证姓名，请输入（点击单字可复制）：</p>
          <div class="name-chars">
            <div class="nchar" data-copy="*" v-for="(item, index) in orderInfo.phoneOwners" :key="index" @click="copyPhoneOwnerOne(item)">{{item}}</div>
          </div>
          <button @click="dialogPhoneOwner=false">我记住了</button>
        </div>
      </div>
    </div>

    <!-- 复制信息弹窗 -->
    <div class="mask " id="mask" v-if="dialogToDy">
      <div class="modal">
        <div class="mh">信息</div>
        <div class="mb">
          <p>您已复制手机号 <b id="mphone">{{orderInfo.phone}}</b></p>
          <p class="red">必须选择 {{orderInfo.amount.toFixed(2)}} 元，打开抖音-我-右上角"≡"-我的钱包-手机充值</p>
          <p>进行支付，否则不到账</p>
          <p class="red">必须粘贴手机号码</p>
          <a class="btn" id="mainBtn" style="display:flex;justify-content: center;" href="snssdk1128://" @click="dialogToDy=false" v-if="orderInfo.paykind==1">
            我知道了 + 打开抖音
          </a>
          <button @click="dialogToDy=false" v-else>
            我知道了
          </button>
        </div>
      </div>
    </div>

    <!-- 支付超时 -->
    <div class="mask" v-if="payTimeInfo.timeLastSss<=0&&orderInfo.statePayd!=true&&orderInfo.csTimeoutClose==true">
      <div class="modal">
        <div class="mh">订单已超时</div>
        <div class="mb" style="text-align:center;">
          <p style="padding:20px;">您的订单支付超时，请关闭页面或重新下单</p>
        </div>
      </div>
    </div>

    <!-- 支付成功 -->
    <div class="mask" v-if="orderInfo.statePayd==true">
      <div class="modal">
        <div class="mh">订单成功</div>
        <div class="mb" style="text-align:center;">
          <p style="padding:20px;">系统已收到您的金额</p>
        </div>
      </div>
    </div>

    <div class="toast" id="toast">已复制手机号</div>

  </div>
</template>

<script>
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    alipInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogPhoneOwner: true,
      dialogToDy: false,
    };
  },
  computed: {},
  created() {
    //设置标题
    document.title = "收银台";
    //加载样式
    this.loadTheme();
  },
  methods: {
    // 动态导入本地 CSS 文件
    async loadTheme() {
      try {
        await import("./product_phone_balance_dy.css");
      } catch (error) {
        //console.error("CSS err", error);
      }
    },
    // 点击复制-单个姓名
    copyPhoneOwnerOne(name) {
      if (name && name == "*") {
        return;
      }
      //复制1
      this.$parent.copySome(
        name,
        1,
        () => {},
        (err) => {
          this.$parent.copyErr();
        }
      );
      // 弹框
      var toast = document.getElementById("toast");
      toast.textContent = '已复制"' + name + '"';
      toast.classList.add("show");
      setTimeout(function () {
        toast.classList.remove("show");
      }, 1000);
    },
    // 去抖音
    gotoDy(num) {
      //复制2
      this.$parent.copySome(
        num,
        2,
        () => {
          this.copyPhoneIf = true;
          if (ifShow) {
            this.showCopy = true;
            setTimeout(() => {
              this.showCopy = false;
            }, 1000);
          }
        },
        (err) => {
          this.$parent.copyErr();
        }
      );
      // 弹框
      var toast = document.getElementById("toast");
      toast.textContent = "手机号已复制";
      toast.classList.add("show");
      setTimeout(function () {
        toast.classList.remove("show");
      }, 1000);
      // 打开弹窗
      this.dialogToDy = true;
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
